module.exports = __webpack_public_path__ + "static/media/1.0c4e6f96.gif";